import type {
  NatureR01Candidate,
  NatureR01Result,
  NatureR01Status,
} from "./natureR01.types";

const HIGH_SIMILARITY_THRESHOLD = 0.85;
const WEAK_SIMILARITY_THRESHOLD = 0.7;

function classifyStatus(topSimilarity: number): NatureR01Status {
  if (topSimilarity >= HIGH_SIMILARITY_THRESHOLD) {
    return "POSIBLE_COINCIDENCIA";
  }

  if (topSimilarity >= WEAK_SIMILARITY_THRESHOLD) {
    return "COINCIDENCIA_DEBIL_REVISAR";
  }

  return "SIN_COINCIDENCIA_SUFICIENTE";
}

export function buildNatureR01Result(
  candidates: NatureR01Candidate[],
  analyzedPart = "unknown",
): NatureR01Result {
  const orderedCandidates = [...candidates].sort(
    (a, b) => b.similarity - a.similarity,
  );

  const topSimilarity = orderedCandidates[0]?.similarity ?? 0;

  return {
    status: classifyStatus(topSimilarity),
    analyzedPart,
    candidates: orderedCandidates.slice(0, 3),
    experimental: true,
    requiresVerification: true,
  };
}

export function similarityLabel(similarity: number): string {
  if (similarity >= HIGH_SIMILARITY_THRESHOLD) {
    return "alta";
  }

  if (similarity >= WEAK_SIMILARITY_THRESHOLD) {
    return "media";
  }

  return "baja";
}